import { render, staticRenderFns } from "./MaterialListItem.vue?vue&type=template&id=d65df3b8&scoped=true"
import script from "./MaterialListItem.vue?vue&type=script&lang=ts"
export * from "./MaterialListItem.vue?vue&type=script&lang=ts"
import style0 from "./MaterialListItem.vue?vue&type=style&index=0&id=d65df3b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65df3b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d65df3b8')) {
      api.createRecord('d65df3b8', component.options)
    } else {
      api.reload('d65df3b8', component.options)
    }
    module.hot.accept("./MaterialListItem.vue?vue&type=template&id=d65df3b8&scoped=true", function () {
      api.rerender('d65df3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/lists/MaterialListItem.vue"
export default component.exports